import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import type { LearningSummaryViewModel, SubjectMasteryViewModel } from '../../types/learningAnalysis';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type MasteryOverviewCardProps = {
  summary: LearningSummaryViewModel;
  subjects: SubjectMasteryViewModel[];
};

export function MasteryOverviewCard({ summary, subjects }: MasteryOverviewCardProps) {
  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <View>
          <AppText variant="caption" tone="muted">
            总体掌握度
          </AppText>
          <AppText variant="metric" weight="bold" tone="primary">
            {summary.overallMasteryPercent}%
          </AppText>
        </View>
        <AppText variant="caption" tone="muted">
          连续学习 {summary.streakDays} 天
        </AppText>
      </View>
      {subjects.slice(0, 3).map((subject) => (
        <View key={subject.id} style={styles.subjectRow}>
          <AppText variant="caption" weight="bold" style={styles.subjectLabel}>
            {subject.subjectName}
          </AppText>
          <View style={styles.progressTrack}>
            <View style={[styles.progressFill, { width: `${subject.masteryPercent}%` }]} />
          </View>
          <AppText variant="caption" tone="muted">
            {subject.masteryPercent}%
          </AppText>
        </View>
      ))}
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: tokens.spacing.md,
  },
  subjectRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
  subjectLabel: {
    width: 44,
  },
  progressTrack: {
    flex: 1,
    height: tokens.layout.progressHeight,
    borderRadius: tokens.radius.full,
    overflow: 'hidden',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  progressFill: {
    height: '100%',
    borderRadius: tokens.radius.full,
    backgroundColor: tokens.colors.primary,
  },
});
